// ============================================================================
// ⚠️  PHI HARD RULE — DO NOT VIOLATE
// Only synthetic SAMPLE data below may ever be sent to the Labelary remote
// preview service (a THIRD-PARTY web service). Real patient/order data —
// name, DOB, MRN, accession/barcode, or anything else derived from a live
// order — must NEVER reach a preview renderer. Previews always fill
// templates with SAMPLE_FIELDS, never with live bindings. Actual printing
// goes straight to the Zebra/DYMO printer and MUST NOT route through
// Labelary. (Ports legacy `Alpha-App/src/util/labelPreview/sampleData.js`.)
// ============================================================================

// Builds a synthetic 10-digit accession serial in the YYMMDD0001 form most
// customers use (2-digit year, month, day, then a per-day sample number). The
// sample reference always uses #0001. Defaults to today so the preview looks
// like a label printed now; no PHI is involved.
export function sampleSerial(date: Date = new Date()): string {
  const yy = String(date.getFullYear()).slice(-2)
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  return `${yy}${mm}${dd}0001`
}

const SAMPLE_SERIAL = sampleSerial()

// Union of legacy `{{tag}}` names (labelTemplate.js DYMO_TEMPLATE_TAGS /
// ZEBRA_TEMPLATE_TAGS, see api-server `db/seed-label-templates.ts`
// LEGACY_TAG_META) and AlphaEdge's native `buildVariableBindings` names (see
// api-server `services/label-render.ts`), so both template families preview
// correctly regardless of which tag vocabulary a body uses.
export const SAMPLE_FIELDS: Record<string, string> = {
  // -- Legacy tags --
  name: 'DOE, JANE (SAMPLE)',
  dob: '01/01/1980',
  barcode: SAMPLE_SERIAL,
  srNo: SAMPLE_SERIAL,
  srNoRaw: SAMPLE_SERIAL,
  code: 'SAMPLE',
  codeValue: 'SAMPLE',
  codeLabel: 'SAMPLE PANEL',
  collectionDate: '01/01/2030',
  collectionSource: 'NASAL SWAB (SAMPLE)',
  swabtype: 'NASAL SWAB (SAMPLE)',
  sampleContainer: 'TUBE-A (SAMPLE)',
  chartId: 'CHART-SAMPLE',
  age: '45',
  gender: 'F',
  fasting: 'N',
  providerName: 'DR. SAMPLE PROVIDER',
  patientAddress: '123 SAMPLE ST, SAMPLETOWN',
  siteName: 'SAMPLE LAB',

  // -- AlphaEdge native variable names (buildVariableBindings) --
  accession_number: SAMPLE_SERIAL,
  order_barcode: SAMPLE_SERIAL,
  patient_name: 'DOE, JANE (SAMPLE)',
  patient_first_name: 'JANE',
  patient_last_name: 'DOE',
  patient_dob: '01/01/1980',
  patient_mrn: 'CHART-SAMPLE',
  patient_initials: 'JD',
  collection_date: '01/01/2030 08:00',
  lab_client_name: 'SAMPLE LAB CLIENT',
  lab_client_code: 'SAMPLE',
  ordering_provider_name: 'DR. SAMPLE PROVIDER',
  ordering_provider_npi: '1234567890',
  site_name: 'SAMPLE LAB',
  org_name: 'SAMPLE ORGANIZATION',
}
